import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import useGlobal from 'hooks/useGlobal'
import api from 'utils/api'
import AdapterLink from 'utils/AdapterLink'
import GradientButton from 'components/common/GradientButton'
import MessagePanel from 'components/admin/message/MessagePanel'
import ConfigPanel from 'components/admin/config/ConfigPanel'
import DbPanel from 'components/admin/db/DbPanel'
import { StoreProvider } from 'hooks/useStore'
import { useSnackbar } from 'notistack'

const useStyles = makeStyles(theme => ({
	content: {
		[theme.breakpoints.up('md')]: {
			marginTop: theme.spacing(6),
			marginBottom: theme.spacing(6),
		},
		[theme.breakpoints.down('sm')]: {
			marginTop: theme.spacing(2),
			marginBottom: theme.spacing(2),
		},
	},
}))

function TabPanel(props) {
	const { children, value, index, ...other } = props

	return (
		<Typography
			component="div"
			role="tabpanel"
			hidden={value !== index}
			id={`tabpanel-${index}`}
			aria-labelledby={`tab-${index}`}
			{...other}
		>
			<Box p={2} minHeight={150}>
				{children}
			</Box>
		</Typography>
	)
}

function Admin({ history }) {
	const classes = useStyles()

	const { enqueueSnackbar } = useSnackbar()
	const [config, authActions] = useGlobal(state => state.config, actions => actions.auth)
	const [tabIndex, setTabIndex] = useState(0)

	function handleChange(event, newValue) {
		setTabIndex(newValue)
	}

	async function logout() {
		try {
			await api.post('/api/logout.php')
			authActions.logout()
			history.push('/')
		} catch (e) {
			enqueueSnackbar('로그아웃 실패', { variant: 'error' })
		}
	}

	useEffect(() => {
		document.title = `${config.wc_title} | 관리자`
	}, [config.wc_title])

	return (
		<StoreProvider>
			<Container maxWidth="md">
				<Paper square className={classes.content}>
					<AppBar color="inherit" position="static" elevation={0}>
						<Tabs variant="fullWidth" textColor="secondary" value={tabIndex} onChange={handleChange}>
							<Tab label="메시지 확인" />
							<Tab label="기본설정" />
							<Tab label="웹박수 DB 관리" />
						</Tabs>
					</AppBar>
					<TabPanel value={tabIndex} index={0}>
						<MessagePanel />
					</TabPanel>
					<TabPanel value={tabIndex} index={1}>
						<ConfigPanel />
					</TabPanel>
					<TabPanel value={tabIndex} index={2}>
						<DbPanel />
					</TabPanel>
					<Divider />
					<Box p={2} display="flex" alignItems="center" justifyContent="space-between">
						<GradientButton color="secondary" variant="outlined" component={AdapterLink} to="/">
							메인으로
						</GradientButton>
						<GradientButton color="secondary" variant="contained" onClick={logout}>
							로그아웃
						</GradientButton>
					</Box>
				</Paper>
			</Container>
		</StoreProvider>
	)
}

export default Admin
